import {
  FETCH_CLAIMS_SUCCESS,
  GET_CLAIM_PDF,
  GET_CLAIM_SUCCESS,
  CLAIMS_LOADING,
  SET_CLAIM_DRAFT,
  SET_CONNECTING_FLIGHT_DRAFT,
  SET_PROBLEMS_DRAFT,
  GET_AIRPORTS,
  SET_AIRPORTS,
  SET_LAWYERS
} from '../constant/actionType';

const initialState = {
  airports: [],
  airportsDraft: {},
  claimDraft: {},
  claims: [],
  connectingFlights: [],
  files: [],
  isClaimLoaded: false,
  isLoaded: false,
  lawyers: [],
  pdfUrl: '',
  selectedClaim: {},
  uploadedFiles: [],
  warningDate: ''
};

const claimReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CLAIMS_SUCCESS:
      return {
        claims: action.data.filteredClaim,
        isLoaded: true,
        warningDate: action.data.warningDate
      };
    case GET_CLAIM_SUCCESS:
      return {
        airportsDraft: {
          arrivalAirport: action.data.claim.arrivalAirport || {},
          departureAirport: action.data.claim.departureAirport || {},
          transferAirports: action.data.claim.transferAirports || []
        },
        claimDraft: action.data.claim,
        connectingFlights: action.data.claim.transferFlights || [],
        files: action.data.files,
        isClaimLoaded: true,
        problems: action.data.problems ?? [],
        selectedClaim: action.data.claim
      };
    case SET_CONNECTING_FLIGHT_DRAFT:
      return {
        ...state,
        connectingFlights: action.data
      };
    case SET_PROBLEMS_DRAFT:
      return {
        ...state,
        problems: action.data
      };
    case CLAIMS_LOADING:
      return {
        ...state,
        isClaimLoaded: false
      };
    case SET_AIRPORTS:
      return {
        ...state,
        airports: action.data
      };
    case SET_LAWYERS:
      return {
        ...state,
        lawyers: action.data
      };
    case GET_AIRPORTS:
      return {
        ...state,
        airports: action.data
      };
    case GET_CLAIM_PDF:
      return { ...state, pdfUrl: action.data };
    case SET_CLAIM_DRAFT:
      return { ...state, claimDraft: action.data };
    default:
      return state;
  }
};

export default claimReducer;
